<template>
  <DenseExpansionPanel>
    <VExpansionPanelHeader
      :hide-actions="addOns.length === 0"
      :class="{ 'search-highlight': isHighlighted(proof.proofId) }"
    >
      <ProofListItem :proof="proof" :base-proof="baseProof" :add-ons="addOns" />
      <!-- If there's no action icon (expand arrow), reserve the space anyways so that all images align -->
      <div v-if="addOns.length === 0" class="flex-grow-0" style="width: 21px" />
    </VExpansionPanelHeader>
    <VExpansionPanelContent>
      <template v-for="addOn in addOns">
        <VDivider :key="addOn.id + '-divider'" />
        <ProofListItem
          :key="addOn.id + '-list-item'"
          :proof="addOn"
          :class="{ 'search-highlight': isHighlighted(addOn.proofId) }"
        />
      </template>
    </VExpansionPanelContent>
  </DenseExpansionPanel>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from 'vue'
import { getModule } from 'vuex-module-decorators'

import DenseExpansionPanel from '@/components/DenseExpansionPanel.vue'
import ProofListItem from '@/components/ProofListItem.vue'
import { Proof } from '@/generated'
import Salesforce from '@/store/modules/salesforce'

export default defineComponent({
  components: {
    DenseExpansionPanel,
    ProofListItem
  },
  props: {
    proof: {
      type: Object as PropType<Proof>,
      required: true
    },
    addOns: {
      type: Array as PropType<Proof[]>,
      required: true
    },
    filterProofIds: {
      type: Array as PropType<string[] | null>,
      default: null
    }
  },
  setup(props) {
    const salesforce = getModule(Salesforce)
    const baseProofSalesforceId = props.proof.baseProof?.id
    const baseProof = baseProofSalesforceId
      ? salesforce.proofBySalesforceId(baseProofSalesforceId)
      : null

    const filterSet = computed(() =>
      props.filterProofIds ? new Set(props.filterProofIds) : null
    )

    return {
      baseProof,
      isHighlighted(proofId: string) {
        return filterSet.value !== null && filterSet.value.has(proofId)
      }
    }
  }
})
</script>
